<div class="k-d-flex k-justify-content-between">
    <div>
        <h1 class="page__heading">{{ pageHeading }}</h1>
        <!-- <h2 class="page__subheading">Submission due {{todayDate | date:'MM/dd/yyyy' }}</h2> -->
        <h2 class="page__subheading">Encounter Attendance</h2>
    </div>
    <div class="provider-card">
        <div class="k-d-flex k-align-items-center k-gap-2">
            <fa-icon icon="user-nurse" size="xl" class="k-mt-2"></fa-icon>
            <strong>Provider: {{serviceEntryDetails?.providerName}} (ID:
                {{serviceEntryDetails?.providerId}})</strong>
            <button kendoButton fillMode="flat" id="provider-details-button" (click)="openProviderDetailsDialog()" aria-label="Provider details"
                class="provider-btn">
                <fa-icon icon="info-circle" size="xl"></fa-icon>
            </button>
        </div>
        <p style="color: var(--tb-kendo-neutral-110); margin-left: 35px;" class="k-m-0">
            Type: {{ providerCardTypeDisplay }}
        </p>
    </div>
</div>
<!-- Approved Note -->
<div class="approved-note k-mt-5 k-d-flex k-align-items-center k-gap-sm" *ngIf="approvedSubmission">
    <kendo-svg-icon [icon]="checkCircleIcon" size="medium"></kendo-svg-icon>
    <p class="k-m-0">
        <strong>
            Submission Approved {{ approvedSubmission.date }}
            by {{ approvedSubmission.supervisor }}.
        </strong>
        Comments:
        {{ approvedSubmission.comments }}
    </p>
</div>

<!-- Rejected Note -->
<div class="rejected-note k-mt-5 k-d-flex k-align-items-center k-gap-sm" *ngIf="rejectedSubmission">
    <kendo-svg-icon [icon]="xmarkCircleIcon" size="medium"></kendo-svg-icon>
    <p class="k-m-0">
        <strong>
            Submission Rejected {{ rejectedSubmission.date }}
            by {{ rejectedSubmission.supervisor }}.
        </strong>
        Reason for Rejection:
        {{ rejectedSubmission.comments }}
    </p>
</div>

<!----Unscheduled Note---->
@if(showUnscheduledNote){
<div class="unscheduled-note k-mt-5">
    <p class="k-m-0"><strong>Note:</strong> Creating an encounter service entry for an unscheduled session will save all
        entered information as both the scheduled and actual service details.</p>
</div>
}
<form [formGroup]="attendanceForm">
    <div class="page__content">
        <div class="k-d-flex gap-20 k-mt-6">
            <div class="">
                <div class="k-d-grid">
                    <kendo-card width="100%" style="background-color: var(--tb-kendo-neutral-20);">
                        <div class="k-p-6">
                            <section class="k-d-grid k-gap-y-lg">
                                <div class="k-d-flex k-justify-content-between">
                                    <h2 class="section__heading">
                                        Details
                                    </h2>
                                    <kendo-buttongroup selection="single">
                                        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark"
                                            (click)="selectTab('scheduled')"
                                            [disabled]="isUnscheduledEncounter">Scheduled</button>
                                        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark"
                                            [selected]="true" (click)="selectTab('actual')">Actual</button>
                                    </kendo-buttongroup>
                                </div>
                                <div class="k-d-grid">
                                    <div class="k-d-flex k-gap-lg k-align-items-center">
                                        <kendo-svg-icon [icon]="chalkBordUser" size="large"></kendo-svg-icon>
                                        @if(!isScheduledTabSelected){
                                        <kendo-formfield class="k-w-full">
                                            <kendo-label text="Service Type" labelCssClass="hidden-label">
                                                <kendo-textbox [readonly]="!isViewAction || !isReviewAction"
                                                    [disabled]="isViewAction || isReviewAction"
                                                    [value]="isUnscheduledEncounter ? serviceEntryDetails?.serviceType?.description : scheduledView?.serviceTypeDesc">
                                                    <!-- [value]="displayServiceType"  -->
                                                </kendo-textbox>
                                            </kendo-label>
                                        </kendo-formfield>
                                        }
                                        @if(isScheduledTabSelected){
                                        <p class="k-m-0">
                                            {{ scheduledView?.serviceTypeDesc }}
                                        </p>
                                        }

                                    </div>
                                    <div class="k-ml-9 ">
                                        @if(!isScheduledTabSelected){
                                        <div class="k-mt-2"> <kendo-formfield class="k-w-full ">
                                                <kendo-label text="Language" labelCssClass="hidden-label">
                                                    <!-- <kendo-dropdownlist placeholder='Language' [valueField]="'id'"
                                                    [data]="languages" [textField]="'description'"
                                                    formControlName="language" [readonly]="true"></kendo-dropdownlist> -->
                                                    <kendo-textbox [readonly]="true"
                                                        [disabled]="isViewAction || isReviewAction"
                                                        [value]="isUnscheduledEncounter ? serviceEntryDetails?.language?.description : scheduledView?.languageDesc">
                                                    </kendo-textbox>
                                                </kendo-label>
                                            </kendo-formfield></div>
                                        }
                                        @if (isScheduledTabSelected) {
                                        <p class="k-m-0 secondary-color">
                                            {{ scheduledView?.languageDesc }}
                                        </p>
                                        }

                                    </div>
                                    <div class="k-mt-2">
                                        <kendo-formfield>
                                            <div class="k-form-field-checkbox-wrap">
                                                <input type="checkbox" kendoCheckBox #makeupSession
                                                    formControlName="makeupSession" />
                                                <kendo-label class="k-checkbox-label" [for]="makeupSession"
                                                    text="This is a makeup session."></kendo-label>
                                            </div>
                                        </kendo-formfield>
                                    </div>
                                </div>
                                <span class="k-form-separator k-m-5"></span>
                                <div class="k-d-grid">
                                    <div class="k-d-flex k-gap-lg k-align-items-center">
                                        <kendo-svg-icon [icon]="clock" size="medium"></kendo-svg-icon>
                                        @if(!isScheduledTabSelected){
                                        <kendo-formfield class="k-w-full ">
                                            <kendo-label text="Date" labelCssClass="hidden-label">
                                                <kendo-datepicker calendarType="classic" formControlName="date"
                                                    placeholder="Date"
                                                    [inputAttributes]="{
                                                        'aria-label': 'Actual Date',
                                                        'aria-describedby': 'date-validation-errors',
                                                        'aria-invalid': (attendanceForm.get('date')?.invalid || dateRangeError || mandateEndDateError) ? 'true' : 'false'
                                                    }"
                                                    (valueChange)="validateDateTime()"></kendo-datepicker>
                                            </kendo-label>
                                        </kendo-formfield>
                                        }
                                        @if (isScheduledTabSelected) {
                                        <p class="k-m-0 ">
                                            {{ scheduledView?.date | date: 'MM/dd/yyyy' }}
                                        </p>
                                        }



                                    </div>
                                    <!-- date-related error -->
                                    <div id="date-validation-errors" class="k-text-error k-text-xs k-ml-8"
                                        role="alert" aria-live="assertive" aria-atomic="true">
                                        <div *ngIf="!isScheduledTabSelected && dateRangeError">
                                            Error: Must be within date range for selected Mandate(s).
                                        </div>
                                        <div *ngIf="!isScheduledTabSelected && mandateEndDateError">
                                            Error: Service date cannot be after the mandate's service end date ({{
                                            earliestMandateEndDate | date:'MM/dd/yyyy' }}).
                                        </div>
                                    </div>
                                    <div class="k-d-flex k-align-items-center k-ml-8 k-gap-x-sm k-flex-wrap">
                                        @if(!isScheduledTabSelected){
                                        <kendo-formfield [style.width.px]="140">
                                            <kendo-label text="Start Time" labelCssClass="hidden-label">
                                                <kendo-timepicker placeholder="Start Time" formControlName="startTime"
                                                    [inputAttributes]="{
                                                        'aria-label': 'Actual Start Time',
                                                        'aria-describedby': 'start-time-validation-errors',
                                                        'aria-invalid': (attendanceForm.get('startTime')?.invalid || startOutsideWindowError || showStartTimeRequiredError || maxDurationError || overlapError || futureTimeError) ? 'true' : 'false'
                                                    }"
                                                    (valueChange)="validateDateTime()" [min]="timeMin" [max]="timeMax">
                                                </kendo-timepicker>
                                            </kendo-label>
                                        </kendo-formfield>
                                        <p class="k-d-flex k-align-items-center">to</p>
                                        <kendo-formfield [style.width.px]="140">
                                            <kendo-label text="End Time" labelCssClass="hidden-label">
                                                <kendo-timepicker placeholder="End Time" formControlName="endTime"
                                                    [inputAttributes]="{
                                                        'aria-label': 'Actual End Time',
                                                        'aria-describedby': 'end-time-validation-errors',
                                                        'aria-invalid': (attendanceForm.get('endTime')?.invalid || endOutsideWindowError || showEndTimeRequiredError || maxDurationError || overlapError || futureTimeError) ? 'true' : 'false'
                                                    }"
                                                    (valueChange)="validateDateTime()" [min]="timeMin" [max]="timeMax">
                                                </kendo-timepicker>
                                            </kendo-label>
                                        </kendo-formfield>
                                        <p>{{ timeRangeText }}</p>
                                        }
                                        @if (isScheduledTabSelected) {
                                        <p class="k-m-0 secondary-color">
                                            {{ scheduledView?.startTime | date:'h:mm a' }}
                                            to
                                            {{ scheduledView?.endTime | date:'h:mm a' }}
                                            ({{ scheduledSessionText }})
                                        </p>
                                        }

                                    </div>

                                    <!-- time-related errors -->
                                    <div class="k-text-error k-text-xs k-ml-8">
                                        <div id="start-time-validation-errors" role="alert" aria-live="assertive"
                                            aria-atomic="true">
                                            <span *ngIf="!isScheduledTabSelected && startOutsideWindowError">
                                            The session time you entered is outside of the acceptable hours of service.
                                            </span>
                                            <span *ngIf="!isScheduledTabSelected && showStartTimeRequiredError">
                                            The Start Time is required in order to save or certify this record.
                                            </span>
                                            <span *ngIf="!isScheduledTabSelected && (maxDurationError &&
                                                !isExcludedServiceTypeForMaxDurationError() || overlapError || futureTimeError)">
                                                <span *ngIf="futureTimeError">
                                                    Error: Service entries cannot be certified with an actual time set in the
                                                    future.
                                                </span>
                                                <span *ngIf="maxDurationError &&
                                                    !isExcludedServiceTypeForMaxDurationError()">
                                                    Error: Maximum duration for this service is 99 minutes.
                                                </span>
                                                <span *ngIf="overlapError">
                                                    Error: Indicated times overlap with an existing encounter.
                                                </span>
                                            </span>
                                        </div>
                                        <div id="end-time-validation-errors" role="alert" aria-live="assertive"
                                            aria-atomic="true">
                                            <span *ngIf="!isScheduledTabSelected && endOutsideWindowError">
                                                The session time you entered is outside of the acceptable hours of service.
                                            </span>
                                            <span *ngIf="!isScheduledTabSelected && showEndTimeRequiredError">
                                            The End Time is required in order to save or certify this record.
                                            </span>
                                            <span *ngIf="!isScheduledTabSelected && (maxDurationError &&
                                                !isExcludedServiceTypeForMaxDurationError() || overlapError || futureTimeError)">
                                                <span *ngIf="futureTimeError">
                                                    Error: Service entries cannot be certified with an actual time set in the
                                                    future.
                                                </span>
                                                <span *ngIf="maxDurationError &&
                                                    !isExcludedServiceTypeForMaxDurationError()">
                                                    Error: Maximum duration for this service is 99 minutes.
                                                </span>
                                                <span *ngIf="overlapError">
                                                    Error: Indicated times overlap with an existing encounter.
                                                </span>
                                            </span>
                                        </div>
                                        <div id="duration-mismatch-error" role="alert" aria-live="assertive" aria-atomic="true">
                                            <span *ngIf="!isScheduledTabSelected && mandateDurationMismatch">
                                                The service duration you have entered does not match with the mandated service duration.
                                            </span>
                                        </div>
                                    </div>
                                    <div class="k-d-flex k-gap-lg k-align-items-center k-mt-6">
                                        <kendo-svg-icon [icon]="locationDot" size="medium"></kendo-svg-icon>
                                        @if(!isScheduledTabSelected){
                                        <kendo-formfield class="k-w-full">
                                            <kendo-label text="Location Type" labelCssClass="hidden-label">
                                                <kendo-dropdownlist [data]="locationTypes" [valueField]="'id'"
                                                    [textField]="'description'" formControlName="locationType"
                                                    placeholder="Location Type"
                                                    [attr.aria-describedby]="'location-type-validation-error'"
                                                    [attr.aria-invalid]="attendanceForm.get('locationType')?.touched &&
                                                        !attendanceForm.get('locationType')?.value ? 'true' : 'false'">
                                                </kendo-dropdownlist>
                                            </kendo-label>
                                        </kendo-formfield>
                                        }

                                        @if (isScheduledTabSelected) {
                                        <p class="k-m-0">
                                            {{ scheduledView?.locationTypeDesc }}
                                        </p>
                                        }


                                    </div>
                                    <div id="location-type-validation-error" class="k-text-error k-text-xs k-ml-8"
                                        role="alert" aria-live="assertive" aria-atomic="true">
                                        <span *ngIf="!isScheduledTabSelected && attendanceForm.get('locationType')?.touched &&
                                            !attendanceForm.get('locationType')?.value">
                                            Error: Location Type is required.
                                        </span>
                                    </div>
                                    <div class="k-ml-8">
                                        @if(!isScheduledTabSelected){
                                        <div class="k-mt-2">
                                            <kendo-formfield class="k-w-full ">
                                                <kendo-label text="Location" labelCssClass="hidden-label">
                                                    <kendo-textbox placeholder="Location"
                                                        formControlName="location"></kendo-textbox>
                                                </kendo-label>
                                            </kendo-formfield>
                                        </div>
                                        }

                                        @if (isScheduledTabSelected) {
                                        <p class="secondary-color k-m-0">
                                            {{ scheduledView?.location }}
                                        </p>
                                        }


                                    </div>
                                    <div class="k-d-flex k-gap-lg k-align-items-center">
                                        <kendo-svg-icon [icon]="stairs" size="medium"
                                            class="k-d-flex k-align-items-center"></kendo-svg-icon>
                                        @if(!isScheduledTabSelected){
                                        <kendo-formfield class="k-w-full k-mt-2">
                                            <kendo-label text="Floor/Room" labelCssClass="hidden-label">
                                                <kendo-textbox placeholder="Floor/Room"
                                                    formControlName="allocatedRoom"></kendo-textbox>
                                            </kendo-label>
                                        </kendo-formfield>
                                        }
                                        @if (isScheduledTabSelected) {
                                        <p class=" k-mt-6 secondary-color">
                                            {{ scheduledView?.floorRoom }}
                                        </p>
                                        }


                                    </div>
                                </div>
                                <div class="k-d-flex k-gap-x-sm">
                                    <kendo-formfield>
                                        <div class="k-d-flex k-gap-lg">
                                            <kendo-label text="Teams Meeting / Tele" [for]="teamsMeetingSwitch">
                                            </kendo-label>
                                            <kendo-switch #teamsMeetingSwitch
                                                formControlName="teamsMeeting"></kendo-switch>
                                        </div>
                                    </kendo-formfield>
                                </div>
                            </section>
                        </div>
                    </kendo-card>
                    <div class="k-d-grid k-gap-md k-p-xl">
                        <kendo-formfield>
                            <div>
                                <input type="checkbox" id="absentForSessionCheckbox" size="medium" kendoCheckBox
                                    formControlName="absentForSession" />
                                <kendo-label class="k-checkbox-label" [for]="'absentForSessionCheckbox'"
                                    text="I was absent for this session."></kendo-label>
                            </div>
                        </kendo-formfield>
                        @if(attendanceForm.get('absentForSession')?.value){
                        <div class="absence-tip-card">
                            <p class="k-m-0"><strong>Tip:</strong> You can now schedule absences directly from your
                                calendar
                                — a new and
                                improved way to mark multiple provider absences at once.</p>
                            <button kendoButton themeColor="primary" fillMode="link" class="k-justify-self-start k-pl-0"
                                (click)="onScheduleAbsence()">Schedule
                                Absence Here</button>
                        </div>
                        }
                        <kendo-formfield>
                            <div>
                                <input type="checkbox" id="supervisorAttendedCheckbox" size="medium" kendoCheckBox
                                    formControlName="supervisorAttended" />
                                <kendo-label class="k-checkbox-label" [for]="'supervisorAttendedCheckbox'"
                                    text="Supervisor attended."></kendo-label>
                            </div>
                        </kendo-formfield>
                        @if(attendanceForm.get('supervisorAttended')?.value){
                        <div>
                            <p class="k-mt-0 k-mb-0 k-ml-8">Attended from:</p>
                            <div class="k-d-flex k-align-items-center k-gap-x-sm k-ml-8 k-flex-wrap">
                                <kendo-formfield [style.width.px]="140">
                                    <kendo-label text="Start Time" labelCssClass="hidden-label">
                                        <kendo-timepicker placeholder="Start Time" formControlName="attendedStartTime"
                                            [inputAttributes]="{
                                                'aria-label': 'Supervisor Attended Start Time',
                                                'aria-invalid': attendanceForm.get('attendedStartTime')?.invalid ? 'true' : 'false'
                                            }"
                                            [min]="timeMin" [max]="timeMax"></kendo-timepicker>
                                    </kendo-label>
                                </kendo-formfield>
                                <p class="k-d-flex k-align-items-center">to</p>
                                <kendo-formfield [style.width.px]="140">
                                    <kendo-label text="End Time" labelCssClass="hidden-label">
                                        <kendo-timepicker placeholder="End Time" formControlName="attendedEndTime"
                                            [inputAttributes]="{
                                                'aria-label': 'Supervisor Attended End Time',
                                                'aria-invalid': attendanceForm.get('attendedEndTime')?.invalid ? 'true' : 'false'
                                            }"
                                            [min]="timeMin" [max]="timeMax"></kendo-timepicker>
                                    </kendo-label>
                                </kendo-formfield>
                                <p>{{attendedTimeRangeText}}</p>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>

            <kendo-card class="k-flex-basis-3/4 k-bg-white">
                <div class="k-p-6">
                    <section class="k-d-grid k-gap-y-xl">
                        <div class="k-d-grid k-d-flex k-gap-sm">
                            <h2 class="section__heading">
                                Attendance
                            </h2>
                            <p class="secondary-color k-m-0">Please mark which students were present or absent, and the
                                corresponding fields based on their attendance. Actual group size for the entry log will
                                be
                                calculated based on marked attendance.</p>
                        </div>
                        <button kendoButton fillMode="outline" themeColor="dark" [svgIcon]="rectangleListIcon"
                            class="k-justify-self-start" (click)="applyAllCptCode()" id="apply-cpt-button"
                            [disabled]="attendanceForm.get('absentForSession')?.value ||!canShowBulkCpt || isReviewAction || isViewAction">Indicate
                            CPT
                            Codes for All</button>
                        <div formArrayName="students" class="attendance-grid-scroll">
                            <kendo-grid #attendanceGrid class="attendance-grid" [scrollable]="'none'"
                                [data]="studentsFA.controls" [loading]="isLoading" [navigable]="false">
                                <kendo-grid-column title="Student"
                                    [headerStyle]="{ 'background-color': 'transparent' }">
                                    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
                                        <div [formGroupName]="rowIndex" tabindex="-1">
                                            <p class="!k-font-semibold k-m-0">{{ row.get('name')?.value }}</p>
                                            <p class="k-m-0">{{ row.get('studentId')?.value }}</p>
                                        </div>
                                    </ng-template>
                                    <ng-template kendoGridFooterTemplate>
                                        <span class="font-semibold">Actual group size: {{ actualGroupSize }} out of {{
                                            scheduledGroupSize }}</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column title="Mandated"
                                    [headerStyle]="{ 'background-color': 'transparent' }">
                                    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
                                        <div [formGroupName]="rowIndex" tabindex="-1">
                                            <p class="k-m-0">{{ row.get('mandatedDescription')?.value }}</p>
                                            <p class="k-m-0">{{ row.get('mandatedLocation')?.value }}</p>
                                        </div>
                                    </ng-template>
                                </kendo-grid-column>

                                <kendo-grid-column
                                    [title]="attendanceForm.get('absentForSession')?.value ? 'Attendance' : 'Attendance *'"
                                    [headerStyle]="{ 'background-color': 'transparent' }">
                                    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
                                        <div [formGroupName]="rowIndex">

                                            <label [ngClass]="{
          'attendance-error':
            row.get('attendance')?.touched &&
            row.get('attendance')?.invalid
        }">
                                                <input type="radio" kendoRadioButton value="Present"
                                                    formControlName="attendance"
                                                    [attr.aria-describedby]="'attendance-error-' + rowIndex"
                                                    [attr.aria-invalid]="row.get('attendance')?.touched && row.get('attendance')?.invalid ? 'true' : 'false'" />
                                                Present
                                            </label>

                                            <label [ngClass]="{
          'attendance-error':
            row.get('attendance')?.touched &&
            row.get('attendance')?.invalid
        }">
                                                <input type="radio" kendoRadioButton value="Absent"
                                                    formControlName="attendance"
                                                    [attr.aria-describedby]="'attendance-error-' + rowIndex"
                                                    [attr.aria-invalid]="row.get('attendance')?.touched && row.get('attendance')?.invalid ? 'true' : 'false'" />
                                                Absent
                                            </label>
                                            <!-- error message -->
                                            <div [id]="'attendance-error-' + rowIndex"
                                                class="attendance-required-error k-mt-2" role="alert"
                                                aria-live="assertive" aria-atomic="true">
                                                <span *ngIf="row.get('attendance')?.touched && row.get('attendance')?.invalid">
                                                    Error: Attendance is required
                                                </span>
                                            </div>

                                        </div>
                                    </ng-template>
                                </kendo-grid-column>

                                <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex"
                                    [kendoGridDetailTemplateShowIf]="showExpectedProgress">

                                    <div class="expected-progress-wrapper">
                                        <div class="expected-progress-line"></div>
                                        <div class="expected-progress-content">
                                            <div class="progress-header">
                                                <strong>Expected Progress</strong>
                                            </div>

                                            <ul class="k-mb-2">
                                                <!-- First attend / encounter -->
                                                <li
                                                    *ngIf="dataItem.get('isFirstAttend')?.value || dataItem.get('isFirstEncounter')?.value">
                                                    <ng-container *ngIf="dataItem.get('isFirstAttend')?.value">
                                                        First Attend
                                                    </ng-container>
                                                    <ng-container *ngIf="dataItem.get('isFirstEncounter')?.value">
                                                        <span *ngIf="dataItem.get('isFirstAttend')?.value">, </span>
                                                        First Encounter
                                                    </ng-container>

                                                    <ul *ngIf="dataItem.get('reasonForDelayText')?.value">
                                                        <li>
                                                            Reason for Delay in First Attend:
                                                            {{ dataItem.get('reasonForDelayText')?.value }}
                                                        </li>
                                                    </ul>
                                                </li>

                                                <!-- Annual goals -->
                                                <!-- <li>
                                                    <strong>annual goals</strong> addressed:
                                                    <ul *ngIf="dataItem.get('annualGoalsSummary')?.value?.length">
                                                        <li
                                                            *ngFor="let goal of dataItem.get('annualGoalsSummary')?.value">
                                                            {{ goal }}
                                                        </li>
                                                    </ul>
                                                </li> -->
                                                <!-- Annual goals -->
                                                <li>
                                                    <ng-container
                                                        *ngIf="dataItem.get('annualGoalsSummary')?.value as goals; else noGoals">
                                                        <ng-container [ngSwitch]="goals.length">

                                                            <!-- Single goal -->
                                                            <ng-container *ngSwitchCase="1">
                                                                <strong>Annual goals addressed:</strong>
                                                                <ul>
                                                                    <li>{{ goals[0] }}</li>
                                                                </ul>
                                                            </ng-container>

                                                            <!-- Multiple goals -->
                                                            <ng-container *ngSwitchDefault>
                                                                <strong>{{ goals.length }} Annual goals
                                                                    addressed:</strong>
                                                                <ul>
                                                                    <li *ngFor="let goal of goals">
                                                                        {{ goal }}
                                                                    </li>
                                                                </ul>
                                                            </ng-container>

                                                        </ng-container>
                                                    </ng-container>

                                                    <ng-template #noGoals>
                                                        <strong>Annual goals addressed:</strong>
                                                    </ng-template>
                                                </li>



                                                <!-- CPT codes -->
                                                <li>
                                                    <strong>{{ dataItem.get('cptCount')?.value || 0 }} CPT
                                                        codes</strong>
                                                    addressed:
                                                </li>

                                                <ul *ngIf="dataItem.get('cptCodesFull')?.value?.length">
                                                    <li *ngFor="let cpt of dataItem.get('cptCodesFull')?.value">
                                                        {{ cpt.cptCode }} - {{ cpt.cptCodeDescription }}
                                                    </li>
                                                </ul>


                                            </ul>

                                            <!-- Session notes -->
                                            <p class="k-mb-2">
                                                {{ dataItem.get('sessionNotesSummary')?.value || 'No session notes to
                                                display' }}
                                            </p>

                                            <p *ngIf="
    dataItem.get('attendance')?.value === 'Absent' &&
    dataItem.get('sessionTypeId')?.value
  " class="k-mb-2">
                                                Session type:
                                                {{
                                                getSessionTypeDescription(
                                                dataItem.get('sessionTypeId')?.value
                                                )
                                                }}
                                            </p>

                                            <!-- Attachments (link‑style) -->
                                            <div *ngIf="dataItem.get('attachmentNames')?.value?.names?.length"
                                                class="attachments">
                                                <fa-icon icon="file-pdf" class="k-mr-2"></fa-icon>
                                                <span
                                                    *ngFor="let file of dataItem.get('attachmentNames')?.value?.names; let i = index"
                                                    (click)="downloadDocument(file)">
                                                    <a class="doc-name">{{ file?.documentName }}</a>
                                                    <span
                                                        *ngIf="i < dataItem.get('attachmentNames')?.value?.names.length - 1">,
                                                    </span>
                                                </span>
                                            </div>

                                            <button kendoButton themeColor="primary" fillMode="flat" size="small"
                                                (click)="onEditExpectedProgress(dataItem)"
                                                [disabled]="attendanceForm.get('absentForSession')?.value || isReviewAction || isViewAction"
                                                class="edit-details-btn k-mt-2">
                                                Edit Details
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>



                                <!-------Student Progress MetaData----->
                                <!-- <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex"
                                    [kendoGridDetailTemplateShowIf]="showStudentProgressMetadata">

                                </ng-template> -->
                            </kendo-grid>

                        </div>
                    </section>


                </div>
            </kendo-card>
        </div>
    </div>
    @if(!locationUser()){
    <div class="time-spent-card k-d-flex k-justify-content-end k-align-items-center">
        <strong>Time Spent Entering Record *</strong>
        @if(isViewAction || isReviewAction){
        <p>{{ attendanceForm.get('timeSpentMinutes')?.value || 0 }} minute(s)</p>
        }
        @if(!isViewAction && !isReviewAction){
        <kendo-formfield [style.width.px]="160">
            <kendo-label text="Minutes" labelCssClass="hidden-label">
                <kendo-textbox formControlName="timeSpentMinutes" [clearButton]="true">
                    <ng-template kendoTextBoxSuffixTemplate>
                        <button kendoButton [disabled]="true">minute(s)</button>
                    </ng-template>
                </kendo-textbox>
            </kendo-label>
        </kendo-formfield>
        }
    </div>
    }
</form>

<div class="separator"></div>
<div class="k-d-flex k-justify-content-between sticky-footer k-mt-4">
    <div class="k-d-flex">
        <kendo-avatar class="avatar k-mt-1" rounded="full" size="medium">
            <fa-icon icon="graduation-cap"></fa-icon>
        </kendo-avatar>
        <div class="k-pl-3">
            <p class="font-12 k-my-0">Currently Working On</p>
            <p class="k-my-0 !k-font-bold">{{studentCountLabel}}</p>
        </div>
    </div>
    <div class="k-d-flex k-gap-sm">
        @if(isReviewAction){
        <button kendoButton themeColor="success" fillMode="solid" [svgIcon]="checkIcon" size="large"
            (click)="onReview('approve')">Approve</button>
        <button kendoButton themeColor="error" fillMode="solid" [svgIcon]="crossIcon" size="large"
            (click)="onReview('reject')">Reject</button>
        <div class="form-separator"></div>
        }
        @if(isEditAction || isCreateAction){
        <p *ngIf="lastSavedTs">
            Last Saved: {{ lastSavedTs | date: 'MM/dd/yyyy, h:mm a' }}
        </p>
        <p *ngIf="!lastSavedTs">
            Last Saved: N/A
        </p>
        <div class="form-separator"></div>
        <button kendoButton themeColor="primary" fillMode="flat" [svgIcon]="saveIcon" size="large"
            (click)="currentStatusId = saveStatusId; onSaveServiceEntry()" [disabled]="!canSave">Save</button>
        <button kendoButton themeColor="primary" fillMode="solid" [svgIcon]="checkDoubleIcon" size="large"
            (click)="currentStatusId = EncounterStatus.Certified; onSaveServiceEntry()"
            [disabled]="!canCertify">Certify</button>
        }

        <button kendoButton themeColor="error" fillMode="outline" [svgIcon]="crossIcon" size="large"
            (click)="onCancel()">Cancel</button>
    </div>
</div>
<!-- </div> -->

<div kendoDialogContainer></div>

@if(isCancelFormSubmission){
<kendo-dialog [minWidth]="86" [width]="530" (close)="closeDialog()" id="cancel-dialog-encounter">
    <kendo-dialog-titlebar>
        Cancel Form Submission</kendo-dialog-titlebar>
    <p class="k-m-0">
        Are you sure you would like to exit from this screen? Any information added will not be saved unless you
        indicate otherwise below.
    </p>
    <kendo-dialog-actions>
        <button kendoButton themeColor="error" (click)="onSaveAndExit()">Save and Exit</button>
        <button kendoButton themeColor="error" fillMode="outline" (click)="onExitWithoutSaving()">
            Exit without Saving
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}

@if(isReasonForDelay){
<kendo-dialog [minWidth]="86" [width]="530" (close)="closeReasonDelayDialog()" id="cancel-reason-delay-dialog">
    <kendo-dialog-titlebar>
        Reason for Delay</kendo-dialog-titlebar>
    <p class="k-m-0">
        An explanation is required for encounters recorded more than 45 days after the date of service. Please provide
        the reason for delay in recording the encounter below.
    </p>
    <kendo-formfield>
        <kendo-floatinglabel text="Reason for Delay *">
            <kendo-textarea rounded="medium" [rows]="3" [(ngModel)]="reasonForDelayInput"></kendo-textarea>
        </kendo-floatinglabel>
    </kendo-formfield>
    <kendo-dialog-actions>
        <button kendoButton themeColor="dark" fillMode="solid">Save Reason and Certify Entry</button>
    </kendo-dialog-actions>
</kendo-dialog>
}

@if(approveRejectDialog){
<kendo-dialog [minWidth]="86" [width]="530" (close)="closeApproveRejectDialog()" id="approve-reject-submission-dialog"
    [ngClass]="approveSubmission ? 'approve' : 'reject'">
    <kendo-dialog-titlebar>
        {{approveSubmission ? 'Approve Submission' : 'Reject Submission'}}</kendo-dialog-titlebar>
    <kendo-formfield>
        <kendo-label [text]="approveSubmission ? 'Comments (Optional)' : 'Reason for Rejection *'">
            <kendo-textarea rounded="medium" [rows]="3" [(ngModel)]="inputApproveReject"
                placeholder="Type here"></kendo-textarea>
        </kendo-label>
    </kendo-formfield>
    <kendo-dialog-actions>
        <button kendoButton [themeColor]="approveSubmission ? 'primary' : 'error'" fillMode="solid"
            (click)="onFinalizeApproveReject()">Finalize</button>
    </kendo-dialog-actions>
</kendo-dialog>
}

@if (showProviderAbsenceConfirm) {
<kendo-dialog [minWidth]="86" [width]="530" (close)="onProviderAbsenceCancel()" id="provider-absence-dialog">
    <kendo-dialog-titlebar>
        Confirm Provider Absence
    </kendo-dialog-titlebar>

    <p class="k-m-0">
        Indicating a session as ‘Provider Absence’ will erase all existing
        attendance information in your service entry. Are you sure you would
        like to continue?
    </p>

    <kendo-dialog-actions>
        <button kendoButton themeColor="error" fillMode="outline" (click)="onProviderAbsenceCancel()">
            No, go back
        </button>
        <button kendoButton themeColor="error" (click)="onProviderAbsenceConfirm()">
            Yes, continue
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
}